import React from 'react';
import './entityViewHeader.scss';
import { StatusTag } from '@/components/common/StatusTag/StatusTag';

// Peacock components
import { PageHeader, Breadcrumb, Tag } from 'pepsico-ds';

/**
 * @param {object} props
 * @param {string} props.title - The main page header text.
 * @param {array}  props.breadcrumbs - Array of breadcrumb items (each has {label, href}).
 * @param {string} [props.tagText] - Optional text for a small Tag label.
 * @param {string} [props.tagColor] - Color for the Tag (e.g. "Gray-500", "Blue-500").
 * @param {array} props.fields - Array of field objects to be displayed.
 * @param {string|null} props.fields[].label - Label for the field (null for no label).
 * @param {string|number} props.fields[].value - Value to display for the field.
 * @param {boolean} [props.fields[].isBold] - Whether to display the value in bold.
 */
export const EntityViewHeader = ({
  title,
  breadcrumbs = [],
  tagText = '',
  tagColor = '#616161',
  fields = []
}) => {
  return (
    <div className='admin-profile_entity-view-header flex flex-col items-start justify-start'>
      <Breadcrumb breadcrumbs={breadcrumbs} />

      <div className='mt-9 flex flex-row items-center justify-start'>
        <PageHeader title={title} />

        {tagText && <StatusTag text={tagText} color={tagColor} />}
      </div>

      <div className='flex flex-row items-center justify-start'>
        {fields.map((field, index) => (
          <React.Fragment key={index}>
            <span
              className={`text-sm ${
                field.isBold ? 'font-medium' : ''
              } text-gray-150`}>
              {field.label ? `${field.label}: ` : ''}
              {field.value ? field.value : '-'}
            </span>
            {index < fields.length - 1 && (
              <span className='mx-4 text-sm text-gray-100'>|</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
